
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.234 6.586V7.89h-.757V6.586h-1.36v-.719h1.36V4.57h.757v1.297h1.368v.719H4.234zm-2.96-.531c0 1.11.195 1.896.585 2.36.391.463 1.055.694 1.993.694.937 0 1.601-.229 1.992-.687.396-.464.593-1.253.593-2.367V.797h1.11v5.398c0 1.287-.318 2.263-.953 2.93-.63.667-1.545 1-2.742 1-1.271 0-2.204-.328-2.797-.984C.46 8.484.165 7.56.165 6.367V.797h1.108v5.258z","fill":"currentColor"}})])
          )
        }
      }
    